import { render, staticRenderFns } from "./call-status.vue?vue&type=template&id=85fea106&scoped=true"
import script from "./call-status.vue?vue&type=script&lang=js"
export * from "./call-status.vue?vue&type=script&lang=js"
import style0 from "./call-status.vue?vue&type=style&index=0&id=85fea106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fea106",
  null
  
)

export default component.exports